import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, input } from '@angular/core';
import { DotCMSEditableTextComponent } from '@dotcms/angular';
import { DotCMSBasicContentlet } from '@dotcms/types';
import { getUVEState } from '@dotcms/uve';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';

import { filterEmaDotcmsPageLinks, onClickEmaDotcmsPageLinks } from '../../utils/dot-cms-uve-utils';

@Component({
  selector: 'custom-dot-uve-cms-web-page-content',
  templateUrl: './dot-cms-uve-web-page-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ServerHtmlDirective, DotCMSEditableTextComponent],
})
export class DotCmsUveWebPageContentComponent implements OnInit, AfterViewInit {
  readonly contentlet = input<DotCMSBasicContentlet>(undefined);
  // readonly setAttribute = input<boolean>(true);
  isInsideEditor = !!getUVEState();
  constructor(private renderer: Renderer2, private el: ElementRef) {}

  ngAfterViewInit() {
    filterEmaDotcmsPageLinks(this.el, this.renderer);
  }

  ngOnInit() {
    onClickEmaDotcmsPageLinks(this.el, this.renderer);
  }
}
